import LoginActionHandlerBase from "./action_handler_base";
import Device from '../../../utils/device/device'

export default class OnRedirectLinkActionHandler extends LoginActionHandlerBase {
    static CLASS = 'OnRedirectLinkActionHandler';
    actionName() {
        return 'onredirectlink';
    }

    execute(params) {

        if(Device.hybrid.inCasino || Device.hybrid.isEmbedded) {
            this.serviceFactory.hybridService().openExternalLink(params.target);
        } else if(this.serviceFactory.integrationService().isMiniOrbit) {
            this.serviceFactory.windowService().openInNewWindow(params.target);
        } else {
            this.serviceFactory.windowService().redirect(params.target);
        }
    }
}